<h1 mat-dialog-title>Versão mínima</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: 500px;">
    <div class="row mt-2">
        <div class="col-sm">
            Ops! Parece que seu navegador não está com a versão mais atualizada do painel.
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-sm">
            Pressione <img style="width: 110px; margin-right: 8px; margin-left: 8px;" title="Shift"
                src="./assets/Shift.webp"> <b>+</b> <img style="height: 50px; margin-right: 8px; margin-left: 8px;"
                title="F5" src="./assets/F5.webp"> se
            o botão de forçar atualização não resolver.
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-sm">
            <hr />
        </div>
    </div>
    <div class="row">
        <div class="col-sm text-right">
            <button mat-flat-button color="warn" (click)="forcarAtualizacao()">
                <mat-icon>cloud_download</mat-icon> Forçar Atualização
            </button>
        </div>
    </div>
</div>